import { RawMeasurementQU } from './Common';

export enum PlantingLocaleGroup {
  APPLICATION_DRY = 'area-density.application.dry-fertilizer',
  APPLICATION_LIQUID = 'volumetric-density',
  AREA = 'area',
  CROP_WATER_USE = 'crop-water-use',
  CROP_HEAT_INDEX = 'crop-heat-index',
  ELEVATION = 'elevation',
  EQUIPMENT_SPEED = 'land-speed',
  MOISTURE = 'humidity',
  POPULATION = 'seed-density',
  POPULATION_SHORT = 'seed-density.seed-density-short',
  POPULATION_WEIGHT = 'seed-density.air-seeder',
  RAINFALL = 'rainfall',
  WEIGHT = 'mass',
  YIELD = 'area-density.yield'
}

export type PlantingPopulation = RawMeasurementQU & {
  localeGroup: PlantingLocaleGroup;
}

export type PlantingData = {
  area?: RawMeasurementQU;
  date?: string;
  hybrids?: string[];
  population?: PlantingPopulation;
  eventType?: string;
}

export type PlantingProducts = {
  id: string;
  name: string;
  plantedArea: number,
  unit: string,
  date: string,
}[];

export type PlantingEventAggregatesResponse = {
  data: {
    field: {
      plantingAnalytics: {
        plantingEventsAggregate: PlantingEventsResponse[]
      }
    }
  }
}

export type PlantingEventsResponse = {
  averageSeedPopulation: { u: string; v: number };
  seasonCode: string;
  seedProduct: { id: string; name: string } | null;
  totalPlantedArea: { u: string; v: number };
  plantingDate: string;
  seedProductId: string;
}


export type PlantingEvent = PlantingData & {
  area: RawMeasurementQU;
  population: PlantingPopulation;
  seedProducts: PlantingProducts;
}

export type PlantingEvents = {
  events: {
    [key: string]: PlantingEvent,
  };
  plantingSeasons: {
    season: string
  }[];
}
